import {gql} from '@apollo/client';

const queryGetSessionParticipantsCode = gql`
    query getSessionParticipantsCode($session_code: String!) {
        getSessionParticipantsCode(session_code: $session_code) {
            identifier
            tag_cloud
            attended
						tower_tag_cloud
						fingerpulse
        }
    }
`;

const queryFetchSessionMarker = gql`
    query fetchSessionMarker($session_code: String!) {
        fetchSessionMarker(session_code: $session_code) {
        marker_title
        marker_id
        marker_type
        start_marker_at
        end_marker_at
        marker_user_id
        deleted
        }
    }
`;

const queryGetExcludedParticipantsBySessionCode = gql`
    query getExcludedParticipantsBySessionCode($session_code: String!) {
        getExcludedParticipantsBySessionCode(session_code: $session_code) {
        	identifier
					exclude_reason
        }
    }
`;

const queryGetNorm = gql`
    query getNorm($session_code: String!) {
        getNorm(session_code: $session_code) {
        imm,
        ps
        }
    }
`;

const queryOverviewNew = gql`
	 query getOverviewData($clip_id: String, $session_code: String!, $from_clip: String, $to_clip: String) {
		 getOverviewData(clip_id: $clip_id, session_code: $session_code, from_clip: $from_clip, to_clip: $to_clip) {
        session_id
        owner_user_id
        session_title
        session_description
        started_at
        ended_at
        scheduled_start_at
        scheduled_end_at
        session_status
        session_type
        small_thumbnail
        large_thumbnail
        session_length
        participantscount                   
        overall_immersion_index
        overall_safety_index
				benchmark_immersion_average
				benchmark_safety_average
				disable_fingerpulse
				tag_wise_immersion{
					tag_name
					overall_index
					overall_tier_indicator
					overall_color_indicator
					overall_context_indicator
				}
				tag_wise_safety{
					tag_name
					safety_index
					tier_indicator
					color_indicator
				}
        immersion_aggregate_index{
            immersion_index
            tier_indicator
            color_indicator
            context_indicator
        } 
        safety_aggregate_index{
            safety_index
            tier_indicator
            color_indicator
            context_indicator
        } 
        best_moments {
            epoch_start
            epoch_end
            immersion_index
            safety_index
            thumbnail
        }
        worst_moments{
            epoch_start
            epoch_end
            immersion_index
            safety_index
            thumbnail
        }
        immersion_contex_breakup{
            order
            context_indicator
            color_indicator
            tier_indicator
            category_count
            category_percent
        }
        safety_contex_breakup{
            order
            context_indicator
            color_indicator
            tier_indicator
            category_count
            category_percent
        }
        immersion_range{
            start
            end
            overall_index
            tier_indicator
            color_indicator
            context_indicator
        }
        safety_range{
            start
            end
            overall_index
            tier_indicator
            color_indicator
            context_indicator
        }
        audience_higher_immersion{
        		tag_name
        		total_paticipant
        		immersion_data{
        			immersion_index
        			safety_index
        			tier_indicator
        			color_indicator
        			context_indicator
        		}
        }
        audience_lower_immersion{
        		tag_name
        		total_paticipant
        		immersion_data{
        			immersion_index
        			safety_index
        			tier_indicator
        			color_indicator
        			context_indicator
        		}
        }
        norm_ps
        norm_imm
        }
    }
`;

const queryTagWise = gql`
    query getOverviewData($clip_id: String, $session_code: String!, $from_clip: String, $to_clip: String) {
        getOverviewData(clip_id: $clip_id, session_code: $session_code, from_clip: $from_clip, to_clip: $to_clip) {
					tag_wise_immersion{
						tag_name
						overall_index
						overall_tier_indicator
						overall_color_indicator
						overall_context_indicator
					}
					tag_wise_safety{
						tag_name
						safety_index
						tier_indicator
						color_indicator
					}
        }
    }
`;

const getCompareTabData = gql`
    query getCompareTabData($compare_session_codes: [JSON!], $session_code: JSON!) {
			getCompareTabData(compare_session_codes: $compare_session_codes, session_code: $session_code) {
					status
					data
        }
    }
`;

const queryGetNeedToKnow = gql`
	query getNeedToKnow($score: String!) {
		getNeedToKnow(score: $score) {
			status
			data
		}
	}
`;

const queryGetCreatorOnboarding = gql`
    query getCreatorOnboarding($user_id: String!) {
        getCreatorOnboarding(user_id: $user_id) {
            preference_id
            user_id
            preference_type
            preference_name
            preference_value
            preference_information
        }
    }
`;

const queryViewProject = gql`
    query viewProject($projectOwnerId: Float!) {
        viewProject(projectOwnerId: $projectOwnerId) {
        projectId
        projectAlias
        projectName
        projectDescription
        tagCloud
        deleted
        active
        createdAt
        updatedAt
        backgroundStimulusId
        iconStimulusId
        departmentId
        projectOwnerId
        cascadedProjectId
        createdBy
        updatedBy
        cascadedProjectOrder
        reels
        }
    }
`;

const queryGetUserAttributes = gql`
    query getUserAttributes($user_id: String!) {
        getUserAttributes(user_id: $user_id) {
        temporary_value
        user_id
        metrics_value
        metrics_id
        }
    }
`;

const queryExperienceCategories = gql`
    query { 
        experienceCategories {
        async {
            cat_subcat_id
            session_type
            experience_type
            category
            display_category
            category_order
            subcategory
            display_subcategory
            icon_url
            created_at
            updated_at
            subcategory_order
            active
            parent_category_id 
            subcategories {
            cat_subcat_id
            session_type
            experience_type
            category
            display_category
            category_order
            subcategory
            display_subcategory
            icon_url
            created_at
            updated_at
            subcategory_order
            active
            parent_category_id 
            }
        }
        moderated {
            cat_subcat_id
            session_type
            experience_type
            category
            display_category
            category_order
            subcategory
            display_subcategory
            icon_url
            created_at
            updated_at
            subcategory_order
            active
            parent_category_id 
            subcategories {
            cat_subcat_id
            session_type
            experience_type
            category
            display_category
            category_order
            subcategory
            display_subcategory
            icon_url
            created_at
            updated_at
            subcategory_order
            active
            parent_category_id 
            }
        }
        }
    }
`;

const queryValidateSessionCode = gql`
    query validateSessionCode($session_code: String!) {
        validateSessionCode(session_code: $session_code)
    }
`;

const queryViewTagsByTypes = gql`
    query viewTagsByTypes($type: Float!,$department_id: String){
        viewTagsByTypes(type: $type,department_id:$department_id) {
        tagId
        createdAt
        updatedAt
        creatorUserId
        tagName
        tagType
        tagDescription
        active
        deleted
        createdBy
        updatedBy
        }
    }
`;

const queryGetSessionParticipants = gql`
	query getSessionParticipants($session_code: String!) {
		getSessionParticipants(session_code: $session_code) {
			main_thumbnail {
				width 
				height 
				url
			}
			participants {
				participant_id
				session_id
				user_id
				temp_email
				last_step
				last_step_at
				participant_status
				tag_cloud
				tower_tag_cloud
				recommended_action
				identifier
				user_devices {
					sensor
					sensor_type
					phone
					phone_type
				}
				indicator
				pid
				passthrough
			}
			session {
				session_trim_to
				session_trim_from
				session_id
				created_at
				updated_at
				agenda_json
				owner_user_id
				session_title
				session_description
				started_at
				ended_at
				scheduled_start_at
				scheduled_end_at
				session_status
				session_type
				session_category
				cancelled_at
				active_at
				deleted_at
				completed_at
				tag_cloud
				background_stimulus_id
				icon_stimulus_id
				related_session_id
				created_by
				updated_by
				session_code
				project_id
				session_subcategory
				customer_id
				stimulus
				owner_company
				owner_first_name
				owner_last_name
				enable_watermark
				enable_controls
				saved_benchmark
				show_banner
				disable_fingerpulse
				using_hub_connectivity
				projects {
					projectId
					projectName
					projectAlias
					customerId
					projectOwnerId
					projectDescription
				}
				stimulusclips {
					immersion_index
					safety_index
					stimulus_length
					end_clip
					start_clip
					title
					immersion_tier_indicator
					immersion_color_indicator
					immersion_context_indicator
					safety_tier_indicator
					safety_color_indicator
					safety_context_indicator
					clip_id
				}
				session_length
				session_trim_to
				session_trim_from
				large_thumbnail
				project_folders
				braintrust_id
				quicktest
				survey_link
				user {
					user_id
					first_name
					last_name
					username
				}
			}
			participant_status {
				total,
				completed,
				in_progress
				not_started,
				error
			}
		}
	}
`;

const queryUpdateThumbnail = gql`
	query updateThumbnail($session_code: String!) {
		updateThumbnail(session_code: $session_code) {
			status
			messagecode
			message
			data  
		}
	}
`;

const queryParticipantExperiences = gql`
    query participantExperiences($page_no: Float, $size: Float) {
        participantExperiences(page_no: $page_no, size: $size){
        sessions {
            session_id
            session_title
            created_at
            updated_at
            owner_user_id
            session_description
            scheduled_start_at
            scheduled_end_at
            session_subcategory
            tag_cloud
            session_code
            session_status
            active_at
            cancelled_at
            completed_at
            session_type
            stimulus
            owner_company
            small_thumbnail
            user {
                first_name
                last_name
            }
            immersion_aggregate_index{
                immersion_index
            }
            safety_aggregate_index {
                safety_index
            }
            session_length
            sessionParticipants {
                identifier
                temp_email
            }
        }
        count
        }
    }
`;

const queryGetExperiencesTotal = gql`
    query getExperiencesTotal($user_id: String!) {
        getExperiencesTotal(user_id: $user_id) {
        status
        data
        }
    }
`;

const querySearch = gql`
	query search(
		$identifier: String!,
		$clip_page_size: Float!,
		$clip_page_no: Float!,
		$size: Float!,
		$page_no: Float!,
		$sort_column: String,
		$sort_direction: String,
		$user_id: [Float!],
		$keyword: String
	) {
		search(
			identifier: $identifier,
			clip_page_size: $clip_page_size,
			clip_page_no: $clip_page_no,
			size: $size,
			page_no: $page_no,
			sort_column: $sort_column,
			sort_direction: $sort_direction,
			user_id: $user_id,
			keyword: $keyword
		) {
			count
			clips_count
			show_user_column
			identifier
			sessions {
				session_id
				project_id
				session_code
				session_title
				session_length
				session_description
				customer_id
				session_type
				session_status
				session_category
				session_subcategory
				owner_user_id
				scheduled_start_at
				scheduled_end_at
				started_at
				completed_at
				ended_at
				created_at
				created_by
				updated_at
				type
				immersion_index
				safety_index
				immersion_color_indicator
				safety_color_indicator
				small_thumbnail
				large_thumbnail
				participantscount
				saved_benchmark
				show_banner
				stimulus_clips {
					clip_id
					immersion_index
					safety_index
					stimulus_length
					end_clip
					start_clip
					title
					safety_tier_indicator
					safety_color_indicator
					safety_context_indicator
					immersion_color_indicator
					immersion_context_indicator
					immersion_tier_indicator
				}
				stimulus_type
				stimulus_status
				project_folders      
				immersion_breakup{
				context_indicator
				category_count
				category_percent
				},
				safety_breakup {
					context_indicator,
					category_count
					category_percent
				}    
				user {
					user_id
					first_name
					last_name
					username
				}
			}
			projects {
				projectName
				projectId
			}
			clips {
				immersion_index
				safety_index
				stimulus_length
				end_clip
				start_clip
				title
				safety_tier_indicator
				immersion_color_indicator
				immersion_context_indicator
				safety_color_indicator
				safety_context_indicator
				immersion_tier_indicator
				clip_id
				session_id
				session_status
				session_title
				session_type
				session_code
			}
		}
	}
`;

const querygetCreatorsList = gql`
    query getCreatorsList{
        getCreatorsList{
            user_id
            username
            alias
            first_name
            middle_name
            last_name
        }
    }
`;


const queryProjectExperiences = gql`
	query getProjectExperiences($project_id: Float!, $sort_column:String, $sort_direction:String) {
		getProjectExperiences(project_id: $project_id, sort_column: $sort_column, sort_direction: $sort_direction) {
			count 
			show_user_column           
			sessions {
				session_id
				project_id
				session_code
				session_title
				session_description
				customer_id
				session_type
				session_status
				session_category
				session_subcategory
				owner_user_id
				scheduled_start_at
				scheduled_end_at
				started_at
				completed_at
				ended_at
				created_at
				created_by
				updated_at
				type
				immersion_index
				safety_index
				immersion_color_indicator
				safety_color_indicator
				small_thumbnail
				large_thumbnail
				participantscount
				session_trim_from
				session_length
				saved_benchmark
				show_banner
				stimulus_clips {
					immersion_index
					safety_index
					stimulus_length
					end_clip
					start_clip
					title
					safety_tier_indicator
					safety_color_indicator
					safety_context_indicator
					immersion_color_indicator
					immersion_context_indicator
					immersion_tier_indicator
					clip_id
				}
				stimulus_type
				stimulus_status
				project_folders      
				immersion_breakup{
					context_indicator
					category_count
					category_percent
				},
				safety_breakup {
					context_indicator,
					category_count
					category_percent
				}    
				user {
					user_id
					first_name
					last_name
					username
				} 
			}
		}
	}
`;

const queryListExperiences = gql`
	query listExperiences(
		$user_id: String!,
		$page_no: Float!,
		$size: Float!,
		$sort_direction: String,
		$sort_column: String,
		$session_ids: [String!]
	) {
		listExperiences(
			user_id: $user_id,
			page_no: $page_no,
			size: $size,
			sort_direction: $sort_direction,
			sort_column: $sort_column,
			session_ids: $session_ids
		) {
			count 
			ownerSessionCount
			show_user_column           
			sessions {
				disable_fingerpulse
				session_id
				project_id
				braintrust_id
				session_code
				session_title
				session_description
				customer_id
				survey_link
				session_type
				session_status
				session_category
				session_subcategory
				owner_user_id
				scheduled_start_at
				scheduled_end_at
				started_at
				completed_at
				ended_at
				created_at
				created_by
				updated_at
				type
				immersion_index
				safety_index
				immersion_color_indicator
				safety_color_indicator
				small_thumbnail
				large_thumbnail
				participantscount
				session_trim_from
				session_length
				saved_benchmark
				show_banner
				stimulus_clips {
					immersion_index
					safety_index
					stimulus_length
					end_clip
					start_clip
					title
					safety_tier_indicator
					safety_color_indicator
					safety_context_indicator
					immersion_color_indicator
					immersion_context_indicator
					immersion_tier_indicator
					clip_id
				}
				stimulus_type
				stimulus_status
				project_folders      
				immersion_breakup {
					context_indicator
					category_count
					category_percent
				},
				safety_breakup {
					context_indicator,
					category_count
					category_percent
				}    
				user {
					user_id
					first_name
					last_name
					username
				}
			}
		}
	}
`;

const queryCheckStimulusStatus = gql`
    query checkStimulusStatus($session_data: [JSON!]!) {
        checkStimulusStatus(session_data: $session_data) {
        count 
        ownerSessionCount
        show_user_column           
        sessions {
            session_id
            project_id
            braintrust_id
            session_code
            session_title
            session_description
            customer_id
            session_type
            session_status
            session_category
            session_subcategory
            owner_user_id
            scheduled_start_at
            scheduled_end_at
            started_at
            completed_at
            ended_at
            created_at
            created_by
            updated_at
            type
            immersion_index
            safety_index
            immersion_color_indicator
            safety_color_indicator
            small_thumbnail
            large_thumbnail
            participantscount
            session_trim_from
            session_length
            stimulus_clips {
                immersion_index
                safety_index
                stimulus_length
                end_clip
                start_clip
                title
                safety_tier_indicator
                safety_color_indicator
                safety_context_indicator
                immersion_color_indicator
                immersion_context_indicator
                immersion_tier_indicator
                clip_id
            }
            stimulus_type
            stimulus_status
            project_folders      
            immersion_breakup{
                context_indicator
                category_count
                category_percent
            },
            safety_breakup {
                context_indicator,
                category_count
                category_percent
            }    
            user{
                user_id
                first_name
                last_name
                username
            } 
        }
        }
    }
`;

const queryGetOtpVdo = gql`
    query getOtpVdo($video_id: String!,$dynamic_watermark:String) {
        getOtpVdo(video_id: $video_id,dynamic_watermark:$dynamic_watermark) {
            data
        }
    }
`;

const queryGetCustomerConfiguration = gql`
    query getCustomerConfiguration($tenant_id: String!) {
        getCustomerConfiguration(tenant_id: $tenant_id) {
            data
        }
    }
`;

const queryGetListExperiancesReels = gql `
	query listExperiencesReels(
		$sort_column: String,
		$sort_direction: String,
		$size: Float!,
		$page_no: Float!,
		$user_id: String!
	) {
		listExperiencesReels(
			sort_column: $sort_column,
			sort_direction: $sort_direction,
			size: $size,
			page_no: $page_no,
			user_id: $user_id
		) {
			count
			sessions {
				reel_sessions
				session_id
				project_id
				survey_link
				session_code
				session_title
				session_description
				customer_id
				session_type
				session_status
				session_category
				session_subcategory
				owner_user_id
				scheduled_start_at
				scheduled_end_at
				started_at
				completed_at
				ended_at
				created_at
				created_by
				updated_at
				type
				immersion_index
				safety_index
				immersion_color_indicator
				safety_color_indicator
				small_thumbnail
				large_thumbnail
				participantscount
				stimulus_clips {
					immersion_index
					safety_index
					stimulus_length
					end_clip
					start_clip
					title
					safety_tier_indicator
					safety_color_indicator
					safety_context_indicator
					immersion_color_indicator
					immersion_context_indicator
					immersion_tier_indicator
				}
				stimulus_type
				stimulus_status
				project_folders
				immersion_breakup{
					context_indicator
					category_count
					category_percent
				},
				safety_breakup {
					context_indicator,
					category_count
					category_percent
				}    
				user {
					user_id
					first_name
					last_name
					username
				}
			}
		}
	}
`;

const queryGetReelSessions = gql`
    query ReelsSession($session_code: String!) {
        ReelsSession(session_code: $session_code) {
            reels{
                session_id
            }
        }
    }
`;

const getHashCode = gql`
    query getHashCode($session_code: String!) {
        getHashCode(session_code: $session_code)
    }
`;
const querygetConnectedSessions = gql`query getConnectedSessions($session_code: [String!]!){
	getConnectedSessions(session_code:$session_code){
		session_type
		session_code
		session_status
		sessionParticipants{
			identifier
			participant_status
		}
	}
}`;

const queryGetShareLink = gql`
    query share($session_code: String!, $clip_data: JSON) {
        share(session_code: $session_code, clip_data: $clip_data) {
            data
            status
            messagecode
            message
        }
    }
`;

const getUserMetricValue = gql`
				query getUserMertixValue($metrix_type: String!, $user_id: Float!) {
        getUserMertixValue(metrix_type: $metrix_type, user_id: $user_id) {
            metrics_value,
            user_id,
            metrics_type,
            last_value,
            temporary_value
        }
    }
`;

const getSelectedListsParticipants = gql`
	query getAllParticipantsList($group_ids: [JSON!]!) {
		getAllParticipantsList(group_ids: $group_ids) {
			id,
			group_id,
			email,
			tags
		}
	}
`;

const getHubsQuery = gql`
	query listHubDevices($department_id: Float, $session_id: Float) {
		listHubDevices(department_id: $department_id, session_id: $session_id) {
			hub_device_id
			department_id
			hub_name
			hub_id
			hub_status
			creator_id
			is_live
			is_associate
			created_at
			updated_at
		}
	}
`;

const closeBanner = gql`
	query closeBanner($session_id: Float!, $user_id: Float!) {
		closeBanner(session_id: $session_id, user_id: $user_id) {
			status
			message
			data
		}
	}
`;

export {
	queryGetSessionParticipantsCode,
	queryFetchSessionMarker,
	queryGetExcludedParticipantsBySessionCode,
	queryGetNorm,
	queryOverviewNew,
	queryGetCreatorOnboarding,
	queryViewProject,
	queryGetUserAttributes,
	queryExperienceCategories,
	queryValidateSessionCode,
	queryViewTagsByTypes,
	queryGetSessionParticipants,
	queryUpdateThumbnail,
	queryParticipantExperiences,
	queryGetExperiencesTotal,
	querySearch,
	querygetCreatorsList,
	queryListExperiences,
	queryCheckStimulusStatus,
	queryProjectExperiences,
	queryGetOtpVdo,
	queryGetCustomerConfiguration,
	queryGetListExperiancesReels,
	getHashCode,
	querygetConnectedSessions,
	queryGetReelSessions,
	queryGetShareLink,
	getUserMetricValue,
	queryGetNeedToKnow,
	getSelectedListsParticipants,
	getHubsQuery,
	closeBanner,
	queryTagWise,
	getCompareTabData
};
